import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['A pile of free drills you still have to sort and sequence', 'A drill that flies with one group flops with the next', 'You build every practice from scratch, every week', 'Half the team standing in line waiting for a rep', 'Your evenings disappear into planning'];
const withIt = ['A full season already planned, practice by practice', 'Every practice in three levels: 6U–8U, 10U–12U, HS & rec', 'Pick the plan, print it, run it', 'Stations so every player is moving the whole time', 'The 4-Block System does the structure for you'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-ice" data-id="element-330" data-mp="295e6x1uowlpx">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-331" data-mp="2d796a0t28p12">
        <div className="text-center" data-id="element-332" data-mp="30y4w4sdyha5o">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-333" data-mp="30x3kalp48jmw">
            Why this isn&apos;t another drill dump
          </p>
          <h2 id="vs-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-4xl sm:text-5xl" data-id="element-334" data-mp="1tetma2kudrs6">
            Free drills vs{' '}
            <span className="text-clay" data-id="element-335" data-mp="235odzmguxjl0">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-336" data-mp="1yeg2mkvyvo57">
            Sure, you can find a hundred softball drills online. Finding drills
            was never the hard part &mdash; turning them into a practice that
            flows, for your age group, with a real warm-up and game situations,
            is. That&apos;s the part this does for you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark shadow-card" data-id="element-337" data-mp="2m1o56v20gj3j">
          <div className="bg-crimson px-3.5 py-4 text-white sm:p-6" data-id="element-338" data-mp="rprb0uc6oz4s">
            <span className="font-display text-2xl uppercase leading-none sm:text-3xl" data-id="element-339" data-mp="rs3rf32an1fq">
              So no
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/80" data-id="element-340" data-mp="2mtfksijvahza">
              YouTube &amp; free PDFs
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-341" data-mp="2rssixzg6vbh6">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-white/95 sm:text-sm" data-id="element-342" data-mp="2vt2ojb02jzvi">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-343" data-mp="35sjtfq7hy9qf">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-344" data-mp="3aq382r83woiw" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-green px-3.5 py-4 text-white sm:p-6" data-id="element-345" data-mp="3jidjgbuqn01q">
            <span className="font-display text-2xl uppercase leading-none text-white sm:text-3xl" data-id="element-346" data-mp="3oirnlit7xpuh">
              So yes
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/85" data-id="element-347" data-mp="3tie0ts91r63a">
              Softball Season-Ready
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-348" data-mp="2h28e3mm90ho">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-349" data-mp="2jey52ym8f5a">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-350" data-mp="3pncsa7d57by9">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-351" data-mp="q8hem7hik1y7" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}